import React, { useState, useEffect } from 'react';
import PCRoutes from '../../Routing/PCRoutes';
import '../../App.css';
import '../../Styles/PC/PCMainContent.css';
import { useLocation } from 'react-router-dom';
import PCHeader from './PCHeader';
import PCSidebar from './PCSidebar';

function PCMainContent() {
    const location = useLocation();
    const [selectedComponent, setSelectedComponent] = useState('ProgrammeUsers');

    const handleComponentSelect = (component) => {
        setSelectedComponent(component);
    };

    useEffect(() => {
        const href = location.pathname.split('/')[2];
        if (href && href !== selectedComponent) {
            setSelectedComponent(href);
        }
    }, [location.pathname]);

    return (
        <div className="pc-container">
            <div className="pc-sidebar-container">
                <PCSidebar handleComponentSelect={handleComponentSelect} selectedComponent={selectedComponent} />
            </div>
            <div className="pc-main-content-container">
                <PCHeader />
                <PCRoutes selectedComponent={selectedComponent}
                    handleComponentSelect={handleComponentSelect}
                />
            </div>
        </div>

    );
}

export default PCMainContent;